export default {
  TYPES: {
    SUCCESS: 'alert-success',
    DANGER: 'alert-danger',
    WARNING: 'alert-warning',
    INFO: 'alert-info'
  }
}
